import { render, staticRenderFns } from "./addposition.vue?vue&type=template&id=de2691fc&scoped=true"
import script from "./addposition.vue?vue&type=script&lang=js"
export * from "./addposition.vue?vue&type=script&lang=js"
import style0 from "./addposition.vue?vue&type=style&index=0&id=de2691fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2691fc",
  null
  
)

export default component.exports